import React, { useEffect, useState, useContext } from 'react';
import { Container, Button, Message} from 'semantic-ui-react'

import { ConnectWS } from '../../../../ConnectWS';
import AuthContext from '../../../../context/authContext';


function BuyTestHotPay(props) {
  const [form, setForm] = useState(null);
  const [message, setMessage] = useState(null);
  const authContext = useContext(AuthContext);


  function generateHotPayDataTest() {
    ConnectWS("/payment/generateHotPayDataTest", authContext.token, {  }, function (response, logout) {

      if (logout === 1) {
        setMessage(response.data)
        setForm(null)
      } else if (response && response.status && Number(response.status) === 200) {
        //setRowDataTournament(response.data)
        setForm(response.data)
        document.getElementById("orderHPTSTestHP").submit();
        setMessage(null)
      } else {

        console.log(response);
        setForm(null)
        setMessage(response)
      }

    });
  }


  useEffect(() => {
    if (props.propsParamsT) {

    }
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container textAlign='center'>
      
              <Button onClick={()=>generateHotPayDataTest()} color='blue'>
                <b>ZAMAWIAM</b>
              </Button>
        
        
      <br />

      {message ? <Message negative>
        <Message.Header>ERROR</Message.Header>
        <p>{message}</p>
      </Message> : ""}

      {form ?
        <form style={{ display: "none" }}
          id="orderHPTSTestHP"
          action="https://platnosc.hotpay.pl/"
          method="post">
          <input required name="SEKRET" value={form.SEKRET} type="hidden" />
          <input required name="HASH" value={form.HASH} type="hidden" />
          <input required name="KWOTA" value={form.KWOTA} type="hidden" />
          <input required name="NAZWA_USLUGI" value={form.NAZWA_USLUGI} type="hidden" />
          <input required name="ADRES_WWW" value={form.ADRES_WWW} type="hidden" />
          <input required name="ID_ZAMOWIENIA" value={form.ID_ZAMOWIENIA} type="hidden" />
          <input name="EMAIL" value={form.EMAIL} type="hidden" />
          <input name="DANE_OSOBOWE" value={form.DANE_OSOBOWE} type="hidden" />
          <button type="submit">Submit</button>
        </form>
        : ""}
    </Container>

  )
}

export default BuyTestHotPay;